import React from "react";
import Carousel from "./Carousel";
import ExploreSection from "./ExploreSection";
import About from "./About";

const HomePage = () => {
  return (
    <div className="homepage">
      
      <Carousel />
      <ExploreSection />
      <About />

    </div>
  );
};

export default HomePage;